var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChevronRight12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MdKeyboardArrowRight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.64625 3.35489C4.45125 3.54989 4.45125 3.86489 4.64625 4.05989L6.58625 5.99989L4.64625 7.93989C4.45125 8.13489 4.45125 8.44989 4.64625 8.64489C4.84125 8.83989 5.15625 8.83989 5.35125 8.64489L7.64625 6.34989C7.84125 6.15489 7.84125 5.83989 7.64625 5.64489L5.35125 3.34989C5.16125 3.15989 4.84125 3.15989 4.64625 3.35489Z",
    fill: "#959595"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight12);
export default __webpack_public_path__ + "static/media/icon_chevron-right-12.5f75736ff5c9b7d80261e550f15aa624.svg";
export { ForwardRef as ReactComponent };